export default "__VITE_PUBLIC_ASSET__3a5256e4__"